import { css, cva } from '@/styled-system/css';

export const containerStyles = cva({
  variants: {
    isFixedPosition: {
      true: {
        background: 'white',
        borderBottom: '{borderWidths.25} solid {colors.gray.300}',
        padding: '400',

        position: 'fixed',
        zIndex: '100002',
        top: 0,
        left: { base: 0, xxl: '{sizes.leftNavWidth}' },
        right: 0,
        width: { base: '100%', xxl: 'calc(100vw - {sizes.leftNavWidth})' },
        animation: 'fadeIn linear 0.2s',
      },
    },
    canAccessListingQuality: {
      false: {
        marginBottom: '600',
      },
    },
  },
});

export const pageContentStyles = css.raw({
  margin: '0 auto',
  padding: '0',
  maxWidth: '1220px',
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: { base: 'column', md: 'row' },
});
